var lastScrollTop = 0;

// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
   var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
   var header = document.querySelector('#header');

   if (st > lastScrollTop){
      if ( header.classList.contains('active') ) {
         header.classList.add('deactive')

         setTimeout(() => {
            header.classList.remove('active')
            header.classList.remove('deactive')
         }, 500)
      } 
      
   } else {
      header.classList.add('active')
   }
   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);


var lastScrollTopDesktop = 0;

// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
   var stdskt = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
   var headerdesktop = document.querySelector('#main-nav');

   lastScrollTopDesktop = stdskt <= 0 ? 0 : stdskt; // For Mobile or negative scrolling
   if(lastScrollTopDesktop == 0){
      headerdesktop.classList.remove('active_desktop');
   }
   if(lastScrollTopDesktop > 40){
      headerdesktop.classList.add('active_desktop');
   }
}, false);